import cx from 'classnames';
import { twMerge } from 'tailwind-merge';

// @TODO(juan): this component is incomplete, need to sync with design to define list of containers. Only centered-md variant is fully tested and usable

type ContainerVariant = 'full' | 'centered-md' | 'centered-sm';

type Props = {
  variant: ContainerVariant;
  className?: string;
};

const variantClass = (variant: ContainerVariant) =>
  cx('flex flex-col w-full grow', {
    'py-24 px-24 2xl:px-[108px] xl:px-[76px] lg:px-[33px]': variant === 'full', // @TODO(juan): untested, don't use yet
    'max-w-md self-center items-start': variant === 'centered-md',
    'max-w-sm self-center items-start': variant === 'centered-sm', // @TODO(juan): untested, don't use yet
  });

/** Used to wrap page's main content section, will handle padding and margins across different screen sizes */
export const ContentContainer: React.FC<Props> = ({ variant, className, children }) => {
  return <div className={twMerge(variantClass(variant), className)}>{children}</div>;
};
